import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Check, X, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { useAuth } from "../App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus("error");
        setErrorMessage("Token de verificación no encontrado");
        return;
      }

      try {
        const res = await axios.post(`${API}/auth/verify-email?token=${token}`);
        login(res.data.token, res.data.user);
        setStatus("success");
        toast.success("¡EMAIL VERIFICADO!");
        
        // Redirect based on user type
        setTimeout(() => {
          if (res.data.user.user_type === "bar") {
            navigate("/dashboard");
          } else {
            navigate("/");
          }
        }, 2000);
      } catch (error) {
        setStatus("error");
        setErrorMessage(error.response?.data?.detail || "Error al verificar email");
      }
    };

    verify();
  }, [token, login, navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[#111] border border-zinc-800 p-8">
          <div className="text-center">
            {status === "verifying" && (
              <>
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Loader2 className="w-8 h-8 text-primary animate-spin" />
                </div>
                <h1 className="text-2xl font-black text-white mb-4">
                  VERIFICANDO...
                </h1>
                <p className="text-zinc-400">
                  Estamos verificando tu email
                </p>
              </>
            )}

            {status === "success" && (
              <>
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Check className="w-8 h-8 text-green-400" />
                </div>
                <h1 className="text-2xl font-black text-white mb-4">
                  ¡EMAIL <span className="text-green-400">VERIFICADO</span>!
                </h1>
                <p className="text-zinc-400 mb-4">
                  Tu cuenta ha sido creada correctamente.
                </p>
                <p className="text-zinc-500 text-sm">
                  Redirigiendo...
                </p>
              </>
            )}

            {status === "error" && (
              <>
                <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <X className="w-8 h-8 text-red-400" />
                </div>
                <h1 className="text-2xl font-black text-white mb-4">
                  ERROR DE <span className="text-red-400">VERIFICACIÓN</span>
                </h1>
                <p className="text-zinc-400 mb-6">
                  {errorMessage}
                </p>
                <div className="space-y-3">
                  <Link to="/register">
                    <Button className="w-full btn-ruido bg-primary text-white font-mono">
                      REGISTRARSE DE NUEVO
                    </Button>
                  </Link>
                  <Link to="/login">
                    <Button variant="outline" className="w-full btn-ruido border-zinc-700 font-mono">
                      INICIAR SESIÓN
                    </Button>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
